import { Asset } from '@/modules/asset/models/Asset';
import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class OpportunityItem extends BaseEntityModel {
  id?: number;
  opportunityId?: number;
  modelId?: number;
  modelType?: string;

  asset?: Relationship<Asset> | null;

  constructor(model: Partial<OpportunityItem> = {}) {
    super(model);

    this.id = model.id;
    this.opportunityId = model.opportunityId;
    this.modelId = model.modelId;
    this.modelType = model.modelType;

    this.asset = Asset.mapModelOrNull(model.asset);
  }
}
